import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ApiResult } from '../../../../shared/models/api-result.model';
import { MessageService } from 'primeng/api';
import { ProductService } from '../../../services/product.service';
import { Product, ProductStatus } from '../../../models/product.model';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectOption } from '../../../../shared/models/dropdowm.model';
import { TagModule } from 'primeng/tag';
import { ToolbarModule } from 'primeng/toolbar';
import { TagStatusComponent } from '../../../../shared/components/tag-status/tag-status.component';
import { SafeHtmlPipe } from '../../../../shared/pipes/safe-html.pipe';

@Component({
  selector: 'app-product-details',
  imports: [
    BreadcrumbModule,
    ButtonModule,
    RouterLink,
    ProgressSpinnerModule,
    TagModule,
    ToolbarModule,
    TagStatusComponent,
    SafeHtmlPipe,
  ],
  templateUrl: './product-details.component.html',
})
export class ProductDetailsComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private productService = inject(ProductService);
  private messageService = inject(MessageService);

  loading = signal(false);
  product = signal<Product | null>(null);

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.loadData(id);
      }
    });
  }

  getStatusDescription(status: ProductStatus): string {
    const option = this.productService
      .getProductStatusOptions()
      .filter((x: SelectOption) => x.value == ProductStatus[status]);
    return option.length > 0 ? option[0].label : '';
  }

  private loadData(id: string): void {
    this.loading.set(true);

    this.productService.getById(id).subscribe({
      next: (response: ApiResult) => {
        this.loading.set(false);
        this.product.set(response.data as Product);
      },
      error: (e) => {
        this.loading.set(false);

        if (e instanceof HttpErrorResponse) {
          this.messageService.add({
            severity: 'error',
            summary: 'Falha',
            detail: 'Ocorreu um erro ao carregar o produto',
            life: 3000,
          });
        }
      },
    });
  }
}
